import { NonNullableRepository } from 'ddd-base';
import { createStorageInstance } from '@/infra/repository/StorageManager';
import { createSSOParams, SSOParams, SSOParamsConverter, SSOParamsJSON } from '@/models/domain/SSOParams';

export class SSOParamsRepository extends NonNullableRepository<SSOParams> {
    private storage: LocalForage;

    constructor(initialEntity: SSOParams) {
        super(initialEntity);
        this.storage = createStorageInstance({
            name: 'SSOParamsRepository',
        });
    }

    /**
     * findを使用する前に呼ぶ必要がある
     */
    async ready(): Promise<SSOParams | null> {
        if (this.map.size > 0) {
            return Promise.resolve(null);
        }
        await this.storage.ready();
        const values: SSOParamsJSON[] = [];
        await this.storage.iterate<SSOParamsJSON, void>((value) => {
            values.push(value);
        });
        const entities = values.map((json) => {
            return SSOParamsConverter.fromJSON(json);
        });
        if (values.length === 0) {
            return null;
        }
        entities.forEach((param) => {
            this.map.set(param.id.toValue(), param);
        });
        await this.save(entities[0]);
        return entities[0];
    }

    save(entity: SSOParams) {
        super.save(entity);
        return this.storage.setItem(entity.id.toValue(), SSOParamsConverter.toJSON(entity));
    }

    async clear() {
        super.clear();
        await this.storage.clear();
    }
}

export const ssoParamsRepository = new SSOParamsRepository(createSSOParams());
